module.exports = __webpack_public_path__ + "static/media/YM58_4.9e420f0f.jpg";